import { DomainError } from '../errors/domain-error';
import { resolveZonedWallTime } from '../events/zoned-date-time';

export function assertMarketingTimezone(timezone: string): string {
  const value = timezone.trim();
  if (!value || value.length > 80) {
    throw new DomainError( 'Timezone is required');
  }
  try {
    new Intl.DateTimeFormat('en-US', { timeZone: value }).format();
  } catch {
    throw new DomainError( 'Enter a valid IANA timezone');
  }
  return value;
}

/**
 * Convert creator wall-clock schedule (`YYYY-MM-DDTHH:mm`) + IANA timezone to UTC instant.
 */
export function resolveMarketingScheduleInstant(input: {
  wallTime: string;
  timezone: string;
  now?: Date;
}): Date {
  const timezone = assertMarketingTimezone(input.timezone);
  const wall = input.wallTime.trim();
  const resolved = resolveZonedWallTime(wall.length === 16 ? `${wall}:00` : wall, timezone);
  if (!resolved.ok) {
    throw new DomainError(
      resolved.reason === 'ambiguous'
        ? 'Scheduled time is ambiguous in that timezone'
        : resolved.reason === 'nonexistent'
          ? 'Scheduled time does not exist in that timezone'
          : 'Scheduled time must be YYYY-MM-DDTHH:mm',
    );
  }
  const now = input.now ?? new Date();
  if (resolved.instant.getTime() <= now.getTime() - 30_000) {
    throw new DomainError( 'Schedule time must be in the future');
  }
  return resolved.instant;
}
